import { ValidationRule, ValidationResult, Value } from '@cnamts/vue-dot/src/rules/types';
import _ from 'lodash';

const defaultErrorMessages = {
	default: 'Le champ n’est pas valide.'
};

export function luhn(errorMessages = defaultErrorMessages): ValidationRule<Value> {
	return (value: Value): ValidationResult => {
		if (!value || _.isEmpty(value)) {
			return true;
		}
		return verifyAlgoLuhn(value) || errorMessages.default;
	};
}

export function verifyAlgoLuhn(value: string): boolean {
	const arrayValue: string[] = replaceCharWithPositionNumber(value.toUpperCase()).split('').reverse();
	const lastNumber = parseInt(arrayValue.shift()!, 10);
	let somme = 0;
	let position = 0;
	_.forEach(arrayValue, (val: string) => {
		position += 1;
		somme += getRealValue(parseInt(val, 10), position);
	});
	const modulo = somme % 10;
	const luhnNumber = modulo === 0 ? modulo : 10 - modulo;
	return luhnNumber === lastNumber;
}

function getRealValue(val: number, position: number) {
	if (position % 2 === 1) {
		const newValue = val * 2;
		return newValue > 9 ? newValue - 9 : newValue;
	} else {
		return val;
	}
}

function replaceCharWithPositionNumber(text: string): string {
	let result: string = '';
	_.forEach(text, (val: string) => {
		const code = val.charCodeAt(0);
		if (code >= 'A'.charCodeAt(0) && code <= 'Z'.charCodeAt(0) ) {
			result += (code - ('A'.charCodeAt(0) - 1));
		} else {
			result += val;
		}
	});

	return result;
}
